import React from 'react';
import { PartnerHub } from './components/PartnerHub';
export function App() {
  return <PartnerHub data-id="element-0" />;
}